import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

import Page from 'components/common/Page'
import BlogContent from 'components/common/BlogContent'
import Card from 'components/common/cards/Card'
import BlogHero from 'components/common/BlogHero'
import ReadyToSignupBlock from 'components/common/blocks/ReadyToSignupBlock'
import SkeletonTitle from 'components/common/skeletons/SkeletonTitle'
import Custom404 from 'pages/404'

import getNested from 'utility/getNested'
import * as educationQuery from 'utility/queries/education';
import { sanitizeInput, cleanHtml } from 'utility/string'

const EducationPostPage = ({ post, categories }) => {
  if (!post || !post?.acf?.hub_page) return <Custom404 />

  const postTitle = getNested(post, 'title', 'rendered')
  const postBody = getNested(post, 'content', 'rendered')
  
  const matchedCategories = categories?.length && post?.education_post_categories?.length ?
    categories.filter((cat) => post?.education_post_categories.includes(cat.id))
    : []
  const matchedCatString = matchedCategories?.length && matchedCategories?.slice(0, 2).map((cat) => `${cat.name} `)

  const SkeletonLoading = (
    <Container>
      <Row>
        <Col xs="12">
          <SkeletonTitle style={{ marginBottom: '30px' }} />
          <SkeletonTitle style={{ marginBottom: '30px' }} />
          <SkeletonTitle style={{ marginBottom: '30px' }} />
          <SkeletonTitle style={{ marginBottom: '30px' }} />
          <SkeletonTitle style={{ marginBottom: '30px' }} />
        </Col>
      </Row>
    </Container>
  )

  return (
    <Page
      title={getNested(post, 'acf', 'meta_title') || postTitle}
      description={
        getNested(post, 'acf', 'meta_description') || sanitizeInput(postBody)
      }
      category={matchedCatString}
      footer
      wedge
      fluid
    >
      <>
        <BlogHero
          height={'20vh'}
          md={'12'}
          body={matchedCatString}
          titleStyle={{ textAlign: 'center' }}
          bodyStyle={{ textAlign: 'center' }}
          title={cleanHtml(postTitle && postTitle.trim())}
        />
        <Container
          style={{ paddingBottom: 20, marginTop: -50, maxWidth: 1200 }}
        >
          <Row style={{ marginBottom: 10 }}>
            <Col>
              <Card style={{ minHeight: '350px' }}>
                {postBody ? (
                  <BlogContent style={{ marginTop: 10 }}>
                    {postBody}
                  </BlogContent>
                ) : (
                  SkeletonLoading
                )}
              </Card>
            </Col>
          </Row>
        </Container>
      </>
      <ReadyToSignupBlock
        titleContainerStyle={{ marginTop: 0, marginBottom: 40 }}
        containerStyle={{ marginTop: 50, marginBottom: 50 }}
      />
    </Page>
  )
}

EducationPostPage.getInitialProps = async ({ query }) => {
  const { postSlug } = query

  const post = await educationQuery.fetchEducationPostBySlug(postSlug)
  const categories = await educationQuery.fetchEducationPostCategories()

  return {
    post: post ? post : null,
    categories: categories ? categories : [],
  }
}

export default EducationPostPage
